var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8020_8784)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8020_8784",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8020_8784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8020_8784)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8355 18.5866H5.7212C5.3229 18.5866 5 18.2637 5 17.8654V10.2789C5 9.8806 5.3229 9.5577 5.7212 9.5577C6.1195 9.5577 6.4423 9.8806 6.4423 10.2789V17.1443H13.5368L17.1442 13.5368V6.4423H6.4423V8.2596C6.4423 8.6579 6.1195 8.9808 5.7212 8.9808C5.3229 8.9808 5 8.6579 5 8.2596V5.7212C5 5.3229 5.3229 5 5.7212 5H17.8654C18.2636 5 18.5865 5.3229 18.5865 5.7212V13.8355C18.5865 14.0267 18.5106 14.2102 18.3753 14.3454L14.3454 18.3753C14.2784 18.4423 14.1989 18.4954 14.1114 18.5317C14.0239 18.5679 13.9302 18.5866 13.8355 18.5866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5875 12.5581H12.5576V16.588",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8020_8784",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8020_8784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogs);
export default __webpack_public_path__ + "static/media/Logs.7f3703d54bcd4468b85aea24de251df2.svg";
export { ForwardRef as ReactComponent };